import { render, staticRenderFns } from "./QuizStudentProfile.vue?vue&type=template&id=faca3bb8&"
import script from "./QuizStudentProfile.vue?vue&type=script&lang=js&"
export * from "./QuizStudentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports